import React from 'react';

export function NotFound() {
  return (
    <section className="page_not_found">{/* <h1>NotFound</h1> */}</section>
  );
}
